module.exports = __webpack_public_path__ + "static/media/closed.c7d301cd.jpg";